import { useLazyQuery } from '@apollo/client';

import { groupsQuery } from './gql';
import { IGroupsVariables, IQueryResult } from './interfaces';

export const useGroupsGql = () => {
  const [runGroupsGql, { loading, data, error }] = useLazyQuery<IQueryResult, IGroupsVariables>(groupsQuery, {
    context: {
      headers: {
        userFunctionKey: 'a684eceee76fc522773286a895bc8436'
      }
    }
  });

  return {
    runGroupsGql,
    loadingGroups: loading,
    dataGroups: data?.groupsProducts || [],
    errorGroups: error
  };
};
